import { Base } from './base.model';
export class PasswordNew {
  public newPassword = new Base();
  public valid = true;

  public resetCustomErrors(): void {
    this.newPassword.errorMessage = '';
  }
}
